<style>
  /* Hide scrollbar for the right container */
  .right-container::-webkit-scrollbar {
    display: none;
  }
  .right-container {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  
  /* Prevent body scroll */
  body {
    overflow: hidden;
  }

  .login-card {
    background-color: white;
    height: 100%;
  }

  /* Hide scrollbar for mobile view container */
  .mobile-scroll {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;     /* Firefox */
  }
  .mobile-scroll::-webkit-scrollbar {
    display: none;             /* Chrome, Safari and Opera */
  }
</style>

<div class="container-fluid vh-100 p-0 overflow-hidden">
  <div class="row h-100 g-0">
    <div class="col-md-5 d-none d-md-block position-relative"
      style="background: url('assets/images/logo/logo-svg.svg') no-repeat center bottom; background-size: 100%;">
      <div class="overlay h-100 d-flex justify-content-center">
        <div class="col-md-10 bg-light-purple text-center position-relative py-4">
          <h1 class="display-7 fs-3 mt-4">{{content?.greeTingtext?.text}}<span 
            [ngClass]="content?.companyNameColorClass?.colorClass" 
            [ngStyle]="{'color': !content?.companyNameColorClass?.colorClass ? content?.companyNameColorClass?.colorCode : null}">
              <span class="div">
                <span class="display-8 fs-3">{{content?.companyName?.unity}}</span>
                <span class="vr vr-dark mx-3 fs-2"></span>
                <span class="display-7 fs-3">{{content?.companyName?.mingle}}</span>
              </span>
            </span></h1>
          <p class="lead fs-6 " style="margin: 2rem;text-wrap: wrap; text-align: center;padding-left: 2%;color: lightslategrey;font-weight: 500;">{{content?.tagline}}</p>

          <div class="position-absolute bottom-0 start-50 translate-middle-x mb-4 w-100">
            <div *ngIf="content?.footerlogos?.unityLogo?.trim() !== '' && content?.footerlogos?.mingleLogo?.trim() !== ''" 
                class="d-flex justify-content-center gap-4">
              <a class="logo">
                <img class="img-fluid" width="50px"
                    [src]="content?.footerlogos?.unityLogo || ' '" 
                    [alt]="content?.footerlogosAlttext?.unity || ' '"/>
              </a>
              <a class="logo">
                <img class="img-fluid" width="50px"
                    [src]="content?.footerlogos?.mingleLogo || ' '" 
                    [alt]="content?.footerlogosAlttext?.mingle || ' '"/>
              </a>
            </div>

            <div *ngIf="(content?.footerlogos?.unityLogo?.trim() !== '' || content?.footerlogos?.mingleLogo?.trim() !== '') 
                     && !(content?.footerlogos?.unityLogo?.trim() !== '' && content?.footerlogos?.mingleLogo?.trim() !== '')"
                class="d-flex justify-content-center">
              <a class="logo" *ngIf="content?.footerlogos?.unityLogo?.trim() !== ''">
                <img class="img-fluid" width="50px"
                    [src]="content?.footerlogos?.unityLogo || ' '" 
                    [alt]="content?.footerlogosAlttext?.unity || ' '"/>
              </a>
              <a class="logo" *ngIf="content?.footerlogos?.mingleLogo?.trim() !== ''">
                <img class="img-fluid" width="50px"
                    [src]="content?.footerlogos?.mingleLogo || ' '" 
                    [alt]="content?.footerlogosAlttext?.mingle || ' '"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-7 col-sm-12 h-100 right-container">
      <div class="login-card p-3 h-100">
        <div class="d-none d-md-flex login-cards justify-content-center align-items-center" style="min-height: 100vh;">
          <div class="d-flex flex-column align-items-center justify-content-center gap-1">
            <div class="row justify-content-center mt-4 ">
              <div class="col-auto">
                <a class="logo">
                  <img class="img-fluid" width="120px" [src]="content.logos.unityLogo || ''" [alt]="content?.altTextForLogo?.unity || ''"/>
                </a>
              </div>
              <div class="col-auto">
                <a class="logo">
                  <img class="img-fluid" width="120px" [src]="content.logos.mingleLogo || ''" [alt]="content?.altTextForLogo?.mingle || ''"/>
                </a>
              </div>
            </div>
  
            <div class="flex-grow-1 d-flex flex-column justify-content-start align-items-center" style="width: 400px;">
              <div class="login-main card shadow p-4 w-100" style="max-width: 400px;" 
                   [class.blink-red-border]="shouldBlink && isChangePasswordRequired">
                <form class="theme-form" [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="on" *ngIf="!isChangePasswordRequired">
                  <h4 class="text-center">Sign in to your account</h4>
                  <p class="text-center text-muted">Enter your username & password to login</p>
            
                  <div class="form-group">
                    <label class="col-form-label">User Name*</label>
                    <input class="form-control" type="text" placeholder="User Name" formControlName="email" name="username"
                      autocomplete="username" />
                  </div>
            
                  <div class="form-group position-relative">
                    <label class="col-form-label">Password*</label>
                    <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password"
                      placeholder="*********" name="password" autocomplete="current-password" />
                    <div class="show-hide position-absolute end-0 me-3 mt-1" style="cursor: pointer;" (click)="showPassword()">
                      <i class="fa" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </div>
                  </div>
            
                  <div class="form-group d-flex justify-content-between align-items-center">
                    <div class="checkbox p-0">
                      <input id="checkbox1" type="checkbox" />
                      <label class="text-muted" for="checkbox1">Remember password</label>
                    </div>
                  </div>
            
                  <button class="btn btn-primary d-block w-100 mt-3" [disabled]="loginForm?.invalid" type="submit">
                    <span>Sign in</span>
                  </button>
                </form>
  
                <form class="theme-form" [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" autocomplete="on" *ngIf="isChangePasswordRequired">
                  <h4 class="text-center">Change Password</h4>
                  <div class=" w-100">
                    <div class=" text-warning text-center p-2" style="word-break: break-word; white-space: normal;">
                      For your account's security, please update your password—it hasn't been changed in a while.
                    </div>
                  </div>
                  
  
                  <div class="form-group">
                    <label class="col-form-label">User Name*</label>
                    <input class="form-control" type="text" placeholder="User Name" formControlName="userName" name="username"
                      autocomplete="username" readonly />
                  </div>
  
                  <div class="form-group position-relative">
                    <label class="col-form-label">Current Password*</label>
                    <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="oldPassword"
                      placeholder="Enter current password" name="oldPassword" autocomplete="current-password" />
                    <div class="show-hide position-absolute end-0 me-3 mt-1" (click)="showPassword()">
                      <i class="fa-regular" [class.fa-eye]="!show" [class.fa-eye-slash]="show"></i>
                    </div>
                  </div>
  
                  <div class="form-group position-relative">
                    <label class="col-form-label">New Password*</label>
                    <input class="form-control" [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
                      placeholder="Enter new password" name="newPassword" autocomplete="new-password" />
                    <div class="show-hide position-absolute end-0 me-3 mt-0" (click)="showNewPasswordField()">
                      <i class="fa-regular" [class.fa-eye]="!showNewPassword" [class.fa-eye-slash]="showNewPassword"></i>
                    </div>
                    <small class="text-muted">Password must be at least 8 characters long</small>
                  </div>
  
                  <div class="form-group position-relative">
                    <label class="col-form-label">Confirm New Password*</label>
                    <input class="form-control" [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                      placeholder="Confirm new password" name="confirmPassword" autocomplete="new-password" />
                    <div class="show-hide position-absolute end-0 me-3 mt-1" (click)="showConfirmPasswordField()">
                      <i class="fa-regular" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
                    </div>
                  </div>
  
                  <div class="form-group" *ngIf="changePasswordForm.hasError('mismatch')">
                    <small class="text-danger">Passwords do not match</small>
                  </div>
  
                  <button class="btn btn-primary d-block w-100 mt-4" [disabled]="changePasswordForm?.invalid" type="submit">
                    Change Password
                  </button>
                </form>
              </div>
            </div>
  
            <div class="mt-auto mb-4">
              <span class="text-muted small d-block">
                <b class="text-dark">Notice :</b>
                {{ content?.notice }}
              </span>
            </div>
          </div>
        </div>

        <!-- Mobile view with hidden scrollbar -->
        <div class="d-md-none h-100 overflow-auto mobile-scroll">
          <div class="d-flex flex-column min-vh-100">
            <!-- Logo section -->
            <div class="row justify-content-center pt-4">
              <div class="col-auto">
                <a class="logo">
                  <img class="img-fluid" width="120px" [src]="content.logos.unityLogo || ''" [alt]="content?.altTextForLogo?.unity || ''"/>
                </a>
              </div>
              <div class="col-auto">
                <a class="logo">
                  <img class="img-fluid" width="120px" [src]="content.logos.mingleLogo || ''" [alt]="content?.altTextForLogo?.mingle || ''"/>
                </a>
              </div>
            </div>

            <!-- Form section -->
            <div class="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
              <div class="login-main card shadow p-4 w-100" style="max-width: 400px;" 
                   [class.blink-red-border]="shouldBlink && isChangePasswordRequired">
                <form class="theme-form" [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="on" *ngIf="!isChangePasswordRequired">
                  <h4 class="text-center">Sign in to your account</h4>
                  <p class="text-center text-muted">Enter your username & password to login</p>
            
                  <div class="form-group">
                    <label class="col-form-label">User Name*</label>
                    <input class="form-control" type="text" placeholder="User Name" formControlName="email" name="username"
                      autocomplete="username" />
                  </div>
            
                  <div class="form-group position-relative">
                    <label class="col-form-label">Password*</label>
                    <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password"
                      placeholder="*********" name="password" autocomplete="current-password" />
                    <div class="show-hide position-absolute end-0 me-3 mt-1" style="cursor: pointer;" (click)="showPassword()">
                      <i class="fa" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </div>
                  </div>
            
                  <div class="form-group d-flex justify-content-between align-items-center">
                    <div class="checkbox p-0">
                      <input id="checkbox1" type="checkbox" />
                      <label class="text-muted" for="checkbox1">Remember password</label>
                    </div>
                  </div>
            
                  <button class="btn btn-primary d-block w-100 mt-3" [disabled]="loginForm?.invalid" type="submit">
                    <span>Sign in</span>
                  </button>
                </form>
  
                <form class="theme-form" [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" autocomplete="on" *ngIf="isChangePasswordRequired">
                  <h4 class="text-center">Change Password</h4>
                  <div class=" w-100">
                    <div class=" text-warning text-center p-2" style="word-break: break-word; white-space: normal;">
                      For your account's security, please update your password—it hasn't been changed in a while.
                    </div>
                  </div>
                  
  
                  <div class="form-group">
                    <label class="col-form-label">User Name*</label>
                    <input class="form-control" type="text" placeholder="User Name" formControlName="userName" name="username"
                      autocomplete="username" readonly />
                  </div>
  
                  <div class="form-group position-relative">
                    <label class="col-form-label">Current Password*</label>
                    <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="oldPassword"
                      placeholder="Enter current password" name="oldPassword" autocomplete="current-password" />
                    <div class="show-hide position-absolute end-0 me-3 mt-1" (click)="showPassword()">
                      <i class="fa-regular" [class.fa-eye]="!show" [class.fa-eye-slash]="show"></i>
                    </div>
                  </div>
  
                  <div class="form-group position-relative">
                    <label class="col-form-label">New Password*</label>
                    <input class="form-control" [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
                      placeholder="Enter new password" name="newPassword" autocomplete="new-password" />
                    <div class="show-hide position-absolute end-0 me-3 mt-0" (click)="showNewPasswordField()">
                      <i class="fa-regular" [class.fa-eye]="!showNewPassword" [class.fa-eye-slash]="showNewPassword"></i>
                    </div>
                    <small class="text-muted">Password must be at least 8 characters long</small>
                  </div>
  
                  <div class="form-group position-relative">
                    <label class="col-form-label">Confirm New Password*</label>
                    <input class="form-control" [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                      placeholder="Confirm new password" name="confirmPassword" autocomplete="new-password" />
                    <div class="show-hide position-absolute end-0 me-3 mt-1" (click)="showConfirmPasswordField()">
                      <i class="fa-regular" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
                    </div>
                  </div>
  
                  <div class="form-group" *ngIf="changePasswordForm.hasError('mismatch')">
                    <small class="text-danger">Passwords do not match</small>
                  </div>
  
                  <button class="btn btn-primary d-block w-100 mt-4" [disabled]="changePasswordForm?.invalid" type="submit">
                    Change Password
                  </button>
                </form>
              </div>
            </div>
  
            <!-- Notice section -->
            <div class="mt-auto mb-4">
              <span class="text-muted small d-block">
                <b class="text-dark">Notice :</b>
                {{ content?.notice }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>